export default function () {
  document.querySelectorAll('[data-waitlist-countdown]').forEach((el) => {
    const countdownTime = el.getAttribute('data-waitlist-countdown-date')
    if (!countdownTime) return
    const ts = new Date(countdownTime).valueOf()
    setInterval(() => {
      const diff = ts - new Date().valueOf()

      const d = diff / 1000 / 60 / 60 / 24
      const h = (d % 1) * 24
      const m = (h % 1) * 60
      const s = (m % 1) * 60

      const output = [
        { value: d, label: 'DAYS' },
        { value: h, label: 'HOURS' },
        { value: m, label: 'MINS' },
        { value: s, label: 'SECS' },
      ].reduce((str, t) => {
        return `${str}<div><span>${Math.floor(t.value)
          .toString()
          .padStart(2, '0')}</span><span>${t.label}</span></div>`
      }, '')

      el.innerHTML = diff < 0 ? 'now' : output
    }, 1000)
  })
}
